var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v(_vm._s(_vm.name))]),
        _c("div", { class: _vm.$style.subHeader }, [
          _vm._v(
            " This is the file you uploaded in ReadyBid format. You can edit each individual user or just click to add your users if everything is in order. "
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "div",
            { class: _vm.$style.bodyTop },
            [
              _vm.erroredUsers === 0
                ? _c(
                    "i",
                    { staticClass: "material-icons", class: _vm.$style.check },
                    [_vm._v("check")]
                  )
                : _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: {
                        [_vm.$style.warning]: true,
                        [_vm.$style.check]: true,
                      },
                    },
                    [_vm._v("warning")]
                  ),
              _c("span", { class: _vm.$style.bodyTopText }, [
                _vm._v(
                  " We found " +
                    _vm._s(_vm.users.length) +
                    " users in the file you uploaded "
                ),
                _vm.erroredUsers > 0
                  ? _c("span", { class: _vm.$style.errorMessage }, [
                      _vm._v(
                        " - " + _vm._s(_vm.erroredUsers) + " errors found"
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "hd-select",
                {
                  class: _vm.$style.sorter,
                  attrs: { items: _vm.sorters },
                  model: {
                    value: _vm.sortBy,
                    callback: function ($$v) {
                      _vm.sortBy = $$v
                    },
                    expression: "sortBy",
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("sort")]),
                  _vm._v(" Sort By - " + _vm._s(_vm.sorter.text) + " "),
                ]
              ),
            ],
            1
          ),
          _c("div", { class: _vm.$style.tableHead }, [
            _c("div", { class: _vm.$style.cellId }, [_vm._v("ID")]),
            _c("div", { class: _vm.$style.cell }, [_vm._v("User Name")]),
            _c("div", { class: _vm.$style.cell }, [_vm._v("Email")]),
            _c("div", { class: _vm.$style.cell }, [_vm._v("Phone Number")]),
            _c("div", { class: _vm.$style.cell }, [_vm._v("Title")]),
            _c("div", { class: _vm.$style.cell }, [_vm._v("Department")]),
            _c("div", { class: _vm.$style.cellAction }, [_vm._v("Actions")]),
          ]),
          _c(
            "div",
            { class: _vm.$style.tableBody },
            _vm._l(_vm.sortedUsers, function (user) {
              return _c("div", { key: user.id, class: _vm.$style.row }, [
                _c("div", { class: _vm.$style.cellId }, [
                  _vm._v(_vm._s(user.id)),
                ]),
                _c(
                  "div",
                  { class: _vm.$style.cell },
                  [
                    user.errorMessages("firstName")
                      ? [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              class: _vm.$style.warning,
                            },
                            [_vm._v("warning")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "rbTooltip simple",
                              attrs: { tooltip: "placement:top-start" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(user.errorMessages("firstName")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(
                      " " +
                        _vm._s(user.firstName) +
                        " " +
                        _vm._s(user.lastName) +
                        " "
                    ),
                    user.errorMessages("lastName")
                      ? [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              class: _vm.$style.warning,
                            },
                            [_vm._v("warning")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "rbTooltip simple",
                              attrs: { tooltip: "placement:top-start" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(user.errorMessages("lastName")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c(
                  "div",
                  { class: _vm.$style.cell },
                  [
                    user.errorMessages("email")
                      ? [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              class: _vm.$style.warning,
                            },
                            [_vm._v("warning")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "rbTooltip simple",
                              attrs: { tooltip: "placement:top-start" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(user.errorMessages("email")) + " "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" " + _vm._s(user.email) + " "),
                  ],
                  2
                ),
                _c(
                  "div",
                  { class: _vm.$style.cell },
                  [
                    user.errorMessages("phone")
                      ? [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              class: _vm.$style.warning,
                            },
                            [_vm._v("warning")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "rbTooltip simple",
                              attrs: { tooltip: "placement:top-start" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(user.errorMessages("phone")) + " "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" " + _vm._s(user.phone) + " "),
                  ],
                  2
                ),
                _c(
                  "div",
                  { class: _vm.$style.cell },
                  [
                    user.errorMessages("jobTitle")
                      ? [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              class: _vm.$style.warning,
                            },
                            [_vm._v("warning")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "rbTooltip simple",
                              attrs: { tooltip: "placement:top-start" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(user.errorMessages("jobTitle")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" " + _vm._s(user.jobTitle) + " "),
                  ],
                  2
                ),
                _c(
                  "div",
                  { class: _vm.$style.cell },
                  [
                    user.errorMessages("department")
                      ? [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              class: _vm.$style.warning,
                            },
                            [_vm._v("warning")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "rbTooltip simple",
                              attrs: { tooltip: "placement:top-start" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(user.errorMessages("department")) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" " + _vm._s(user.department) + " "),
                  ],
                  2
                ),
                _c("div", { class: _vm.$style.cellAction }, [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: _vm.$style.action,
                      on: {
                        click: function ($event) {
                          return _vm.edit(user)
                        },
                      },
                    },
                    [_vm._v("edit")]
                  ),
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: _vm.$style.action,
                      on: {
                        click: function ($event) {
                          return _vm.drop(user)
                        },
                      },
                    },
                    [_vm._v("delete")]
                  ),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButton mainButton",
              attrs: { disabled: _vm.erroredUsers > 0 },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("group_add")]),
              _vm._v(" Add Users "),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }